import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["id", "data-redirect", "data-no-redirect"];
const _hoisted_2 = { class: "modal__top" };
const _hoisted_3 = {
    key: 0,
    class: "modal__title"
};
const _hoisted_4 = { class: "modal__close" };
const _hoisted_5 = { class: "btn__icon" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = { class: "modal__bottom" };
const _hoisted_9 = { class: "line line--jcc" };
const _hoisted_10 = { class: "line__item" };
import { computed, onMounted, useSlots, useTemplateRef, watch } from "vue";
import Icon from "../Icon.vue";
import { closeDialogModal, showDialogModal } from "../modal";
import CloseButton from "./CloseButton.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModalDialog',
    props: {
        id: { type: String, required: true },
        size: { type: String, default: 'md' },
        modifier: String,
        title: { type: String },
        mainBlockModifier: String,
        open: { type: Boolean, default: true },
        disabled: Boolean,
        redirect: String,
        noRedirect: Boolean,
    },
    emits: ["submit"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const closeBtn = useTemplateRef('closeBtn');
        const modal = useTemplateRef('modal');
        const props = __props;
        const emit = __emit;
        __expose({ close, open, isOpen, wrapper: modal });
        const slots = useSlots();
        const classes = computed(() => {
            let classes = [];
            classes.push(`modal--${props.size}`);
            if (props.modifier) {
                classes.push(`modal--${props.modifier}`);
            }
            return classes;
        });
        function close() {
            closeBtn.value?.click();
        }
        function open() {
            if (modal.value) {
                showDialogModal(modal.value);
            }
        }
        function isOpen() {
            return modal.value?.open;
        }
        watch(() => props.open, isOpen => isOpen ? open() : close());
        onMounted(() => props.open && open());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("dialog", {
                class: _normalizeClass(["modal", classes.value]),
                id: __props.id,
                ref_key: "modal",
                ref: modal,
                "data-redirect": __props.redirect,
                "data-no-redirect": __props.noRedirect ? '' : null
            }, [
                _createElementVNode("form", {
                    class: "modal__wrapper",
                    onSubmit: _cache[1] || (_cache[1] = ($event) => (emit('submit', $event)))
                }, [
                    _createElementVNode("div", _hoisted_2, [
                        _renderSlot(_ctx.$slots, "top", {}, () => [
                            (__props.title || _unref(slots).title)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                    _renderSlot(_ctx.$slots, "title", {}, () => [
                                        _createTextVNode(_toDisplayString(__props.title), 1 /* TEXT */)
                                    ])
                                ]))
                                : _createCommentVNode("v-if", true)
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn--4 btn--m btn--gray btn--icon",
                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (_unref(closeDialogModal)(modal.value)), ["prevent"])),
                                tabindex: "-1",
                                ref_key: "closeBtn",
                                ref: closeBtn
                            }, [
                                _createElementVNode("span", _hoisted_5, [
                                    _createVNode(Icon, {
                                        name: "cross",
                                        size: 24
                                    })
                                ])
                            ], 512 /* NEED_PATCH */)
                        ]),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _renderSlot(_ctx.$slots, "more")
                    ]),
                    _cache[4] || (_cache[4] = _createTextVNode()),
                    _renderSlot(_ctx.$slots, "under_top"),
                    _cache[5] || (_cache[5] = _createTextVNode()),
                    _createElementVNode("div", {
                        class: _normalizeClass(["modal__main", __props.mainBlockModifier ? `modal__main--${__props.mainBlockModifier}` : ''])
                    }, [
                        _renderSlot(_ctx.$slots, "main_outer", {}, () => [
                            _createElementVNode("fieldset", {
                                class: "modal__body always-visible",
                                disabled: __props.disabled
                            }, [
                                _renderSlot(_ctx.$slots, "main")
                            ], 8 /* PROPS */, _hoisted_6)
                        ])
                    ], 2 /* CLASS */),
                    _cache[6] || (_cache[6] = _createTextVNode()),
                    (_unref(slots).bottom)
                        ? (_openBlock(), _createElementBlock("fieldset", {
                            key: 0,
                            class: "modal__bottom always-visible",
                            disabled: __props.disabled
                        }, [
                            _renderSlot(_ctx.$slots, "bottom")
                        ], 8 /* PROPS */, _hoisted_7))
                        : _renderSlot(_ctx.$slots, "bottom_outer", { key: 1 }, () => [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                        (modal.value)
                                            ? (_openBlock(), _createBlock(CloseButton, {
                                                key: 0,
                                                modal: modal.value
                                            }, null, 8 /* PROPS */, ["modal"]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ])
                            ])
                        ])
                ], 32 /* NEED_HYDRATION */)
            ], 10 /* CLASS, PROPS */, _hoisted_1));
        };
    }
});
